import { Tabs } from 'antd';
import React, { useState } from 'react';
import { FilePickerActiveCaseListContainer } from './file-picker-active-case-list.container';
import { FilePickerArchivedCaseListContainer } from './file-picker-archived-case-list.container';

interface FilePickerCaseListProps {
  setCaseInfo: (selectedCaseId: string, selectedCaseType: string, selectedIsArchived?: boolean) => void;
  applicantName: string;
  applicantId: string;
}
export const FilePickerCaseListTabKey = {
  ACTIVE: 'Active',
  ARCHIVED: 'Archived'
}
export const FilePickerCaseList: React.FC<FilePickerCaseListProps> = (props) => {
  const [selectedTab, setSelectedTab] = useState(FilePickerCaseListTabKey.ACTIVE);

  const handleTabChange = (key: string) => {
    setSelectedTab(key);
  };

  const items = [
    {
      label: 'Active',
      key: FilePickerCaseListTabKey.ACTIVE,
      children: <FilePickerActiveCaseListContainer selectedTab={selectedTab} setCaseInfo={props.setCaseInfo} applicantName={props.applicantName} applicantId={props.applicantId} />
    },
    {
      label: 'Archived',
      key: FilePickerCaseListTabKey.ARCHIVED,
      children: <FilePickerArchivedCaseListContainer selectedTab={selectedTab} applicantId={props.applicantId} setCaseInfo={props.setCaseInfo} applicantName={props.applicantName} />
    }
  ];

  return (
    <div>
      <Tabs items={items} onChange={handleTabChange}/>
    </div>
  );
};
